import React from 'react';

type Tone = 'default' | 'muted' | 'glass' | 'highlight';

interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
  tone?: Tone;
  interactive?: boolean;
}

export const Card: React.FC<CardProps> = ({
  tone = 'default',
  interactive,
  className,
  children,
  ...rest
}) => {
  const toneClasses: Record<Tone, string> = {
    default:
      'border border-white/90 bg-white/95 shadow-[0_12px_40px_-12px_rgba(59,51,133,0.1),0_0_0_1px_rgba(132,165,157,0.08)]',
    muted:
      'border border-borderSoft/40 bg-gradient-to-br from-brandCream/50 to-white/90 shadow-[0_8px_32px_-10px_rgba(59,51,133,0.08)]',
    glass: 'border border-white/70 bg-white/75 backdrop-blur-xl shadow-[0_12px_40px_-14px_rgba(59,51,133,0.1)]',
    highlight:
      'border border-brandLilac/20 bg-gradient-to-br from-brandLilac/[0.08] via-white to-brandSage/[0.12] shadow-[0_12px_40px_-12px_rgba(118,119,228,0.15)]'
  };

  return (
    <div
      className={[
        'rounded-[1.35rem] px-5 py-4 sm:px-6 sm:py-5',
        toneClasses[tone],
        interactive
          ? 'transition-all duration-200 ease-soft-spring hover:shadow-soft-elevated active:scale-[0.99]'
          : '',
        className
      ]
        .filter(Boolean)
        .join(' ')}
      {...rest}
    >
      {children}
    </div>
  );
};


